'use strict';

exports.__esModule = true;
exports.default = isStyledComponent;

var babelPluginFlowReactPropTypes_proptype_Target = require('../types').babelPluginFlowReactPropTypes_proptype_Target || require('prop-types').any;

function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/styled-components/lib/utils/isStyledComponent.js
 ** module id = 140
 ** module chunks = 0
 **/